import DocumentFilesConfirmation from "@/components/FilesConfirmation/DocumentFilesConfirmation";
import { ImageFilesConfirmation } from "@/components/FilesConfirmation/ImageFilesConfirmation";
import { VideoFilesConfirmation } from "@/components/FilesConfirmation/VideoFilesConfirmation";
import { Loading } from "@/components/Loading/Loading";
import { useCurrentUploadQuery } from "@/hooks/uploads";
import { useCurrentUploadId } from "@/hooks/uploads";
import { toRouteError } from "@/errors/routeError";

export const FilesConfirmationPage = () => {
  const currentUploadQuery = useCurrentUploadQuery();
  const uploadId = useCurrentUploadId();

  if (currentUploadQuery.isError) {
    throw toRouteError(currentUploadQuery.error, {
      scope: "upload",
      uploadId,
    });
  }

  if (!currentUploadQuery.isSuccess) {
    return <Loading text="Loading current upload request data" />;
  }

  const { type: uploadType } = currentUploadQuery.data || {};

  return (
    <div className="center">
      {uploadType === "IMAGE" && <ImageFilesConfirmation />}
      {uploadType === "VIDEO" && <VideoFilesConfirmation />}
      {uploadType === "DOCUMENT" && <DocumentFilesConfirmation />}
    </div>
  );
};
